<template>
  <div
    v-if="showBanner"
    class="flex flex-1 flex-row bg-bubblegum-50 items-center space-x-2 px-standard pt-4 pb-3 text-xs lg:text-sm text-neutral-900"
  >
    <i18n
      v-if="isSubscription"
      path="quote.book-this-appointment-with-a-html"
      tag="span"
    >
      <template #planName>
        <span class="text-bubblegum-700 font-semibold">{{ planName }}</span>
      </template>
      <template
        v-if="hasPromotion"
        #originalPrice
      >
        <div class="inline-block line-through">
          {{ formattedOriginalMonthlyAmount }}
        </div>
      </template>
      <template #price>
        <div class="inline-block">
          {{ formattedMonthlyAmount }}
        </div>
      </template>
      <template #frequency>
        <div class="inline-block">
          /{{ $t('membership-subscriptions.monthly-abbreviation') }}
        </div>
      </template>
    </i18n>
    <i18n
      v-else
      path="search.this-appointment-can-be-included-with-plan-name"
      tag="span"
    >
      <template #planName>
        <span class="text-bubblegum-700 font-semibold">{{ planName }}</span>
      </template>
      <template
        v-if="hasPromotion"
        #originalPrice
      >
        <div class="inline-block line-through">
          {{ formattedOriginalMonthlyAmount }}
        </div>
      </template>
      <template #price>
        <div class="inline-block">
          {{ formattedMonthlyAmount }}
        </div>
      </template>
      <template #frequency>
        <div class="inline-block">
          /{{ $t('membership-subscriptions.monthly-abbreviation') }}
        </div>
      </template>
      <template #ctaName>
        <span class="font-semibold">
          {{ getCtaName }}
        </span>
      </template>
    </i18n>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { mapGetters } from 'vuex';

import useCheckoutHelpers from '@/composables/use-checkout-helpers';
import HasYearlySubscriptionPlan from '@/mixins/HasYearlySubscriptionPlan';

export default {
  name: 'VetsterQuoteTotalBanner',

  mixins: [HasYearlySubscriptionPlan],

  props: {
    ctaLabel: {
      type: String,
      default: null,
    },
  },

  setup() {
    const root = getCurrentInstance().proxy.$root;
    const { isSubscription } = useCheckoutHelpers(root);

    return { isSubscription };
  },

  computed: {
    ...mapGetters('subscriptions', ['canPurchaseSubscriptionPlan']),
    getCtaName() {
      return this.ctaLabel ?? this.$t('app.book-now');
    },
    showBanner() {
      return this.annualAmount && this.canPurchaseSubscriptionPlan;
    },
  },
};
</script>
